/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agency: NonNullable<unknown> }} Portalsignin_TitleInputs */

const en_portalsignin_title = /** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign in to ${i?.agency}`)
};

/** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */
const ar_portalsignin_title = en_portalsignin_title;

/** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */
const he_portalsignin_title = en_portalsignin_title;

/** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */
const ur_portalsignin_title = en_portalsignin_title;

/** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */
const es_portalsignin_title = en_portalsignin_title;

/** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */
const fr_portalsignin_title = en_portalsignin_title;

/** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */
const de_portalsignin_title = en_portalsignin_title;

/** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */
const pt_portalsignin_title = en_portalsignin_title;

/** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */
const hi_portalsignin_title = en_portalsignin_title;

/** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */
const bn_portalsignin_title = en_portalsignin_title;

/**
* | output |
* | --- |
* | "Sign in to {agency}" |
*
* @param {Portalsignin_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_title = /** @type {((inputs: Portalsignin_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_title(inputs)
	if (locale === "he") return he_portalsignin_title(inputs)
	if (locale === "ur") return ur_portalsignin_title(inputs)
	if (locale === "es") return es_portalsignin_title(inputs)
	if (locale === "fr") return fr_portalsignin_title(inputs)
	if (locale === "de") return de_portalsignin_title(inputs)
	if (locale === "pt") return pt_portalsignin_title(inputs)
	if (locale === "hi") return hi_portalsignin_title(inputs)
	if (locale === "bn") return bn_portalsignin_title(inputs)
	return en_portalsignin_title(inputs)
});